module.exports = __webpack_public_path__ + "img/efficient-travelling.d4744248.png";